import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import AllPayments from 'routes/Payments/PaymentList/components/AllPayments';
import Transactions from './components/Transactions';
import Funding from './components/Funding';
import ChargeBacks from './components/Chargebacks';

type Props = {
  location: {
    pathname: string
  },
};

const ViewActivity = (props: Props) => {
  const [current, setCurrent] = useState('paymenttransactions');
  const {
    location,
  } = props;

  const setMenu = (query) => {
    switch (query) {
      case '/payments/transactions': {
        setCurrent('paymenttransactions');
        break;
      }
      case '/payments/funding': {
        setCurrent('paymentfunding');
        break;
      }
      case '/payments/chargebacks': {
        setCurrent('paymentcharge');
        break;
      }
      case '/payments/allpayments': {
        setCurrent('allPayments');
        break;
      }
      default:
        setCurrent('paymenttransactions');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="paymenttransactions">
          <SpTab
            to="/payments/transactions"
            selected={current === 'paymenttransactions'}
          >
            TRANSACTIONS
          </SpTab>
        </Menu.Item>
        <Menu.Item key="paymentfunding">
          <SpTab
            to="/payments/funding"
            selected={current === 'paymentfunding'}
          >
            FUNDING
          </SpTab>
        </Menu.Item>
        <Menu.Item key="paymentcharge">
          <SpTab
            to="/payments/chargebacks"
            selected={current === 'paymentcharge'}
          >
            CHARGEBACKS
          </SpTab>
        </Menu.Item>
        <Menu.Item key="allPayments">
          <SpTab
            to="/payments/allpayments?status.IN=ALL_PAYMENTS"
            selected={current === 'allPayments'}
          >
            ALL PAYMENTS
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/payments/transactions" component={Transactions} />
        <Route exact path="/payments/funding" component={Funding} />
        <Route exact path="/payments/chargebacks" component={ChargeBacks} />
        <Route exact path="/payments/allpayments" component={AllPayments} />
      </Switch>
    </div>
  );
};

export default withRouter(ViewActivity);
